import React, { PropsWithChildren, useEffect, useRef, useState } from "react";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { Dropdown, Layout, Menu } from 'antd';
import { createBrowserHistory } from 'history';

//Internal Components
import packProps from '../../../../package.json';
import SearchText from "../SearchText/SearchText";
import { COLORS } from "../../constants/colors";
import Modal from "../Modal/Modal";
import ConfirmationModal from "../Modal/CorfimationModal";
import Configuration from "../../pages/Configuration/Configuration";
import { useAuth } from "../../../contexts/auth";
import { getError, openNotification, tryCatch } from "../../constants/Utilities";
import { IMenu } from "../../../interfaces/IMenu";
import './MenuLayout.css';

interface Props extends PropsWithChildren<any> {
    children: any;
    currentPage: string;
}

const { Header, Sider, Content } = Layout;

const MenuLayout: React.FC<Props> = ({ children, currentPage }) => {

    // States Context
    const { menuCollapsed, menuFixed, setMenuCollapsed, setMenuFixed, userInformation, signOut, setItemSelected, itemSelected, menuPlane, search, menuSearch, searchText, signed } = useAuth();

    // States
    const [closeSessionLoading, setCloseSessionLoading] = useState<boolean>(false);
    const [visibleConf, setVisibleConf] = useState<boolean>(false);
    const [visibleClose, setVisibleClose] = useState<boolean>(false);
    const [askBeforeClosing, setAskBeforeClosing] = useState<boolean>(false);


    // Vars
    const navigate = useNavigate();
    const location = useLocation();

    //Effects
    useEffect(() => {
        const locationPath = menuPlane.current.find((menu: IMenu) => "/bisformulario" + menu.link === location.pathname);

        if (!!locationPath) {
            setItemSelected(locationPath);
        }
    }, [menuPlane])


    const ConfigurationOptions = (): JSX.Element => (
        <div className="menu_confCase">
            <div className="configOption" onClick={() => setVisibleConf(true)}>
                Configuración
            </div>
            <div className="configOption" onClick={() => setVisibleClose(true)}>
                Cerrar Sesión
            </div>
        </div>
    );

    const navigateTo = (menuKey: number) => {
        const page = menuPlane.current.find((menu: IMenu) => menu.menuID === menuKey);
        setItemSelected(page);
        navigate(`/${packProps.homepage}` + page!.link);
    }


    // Handles
    const handleSignOut = () => {
        tryCatch(() => {
            setCloseSessionLoading(true);
            signOut()
                .then((response) => {
                    openNotification('success', 'Sessión Cerrada', response);
                })
                .catch((error) => {
                    openNotification('error', 'Error', getError(error));
                })
                .finally(() => {
                    setCloseSessionLoading(false);
                })
        })
    }

    return (
        <Layout className="menuLayout">
            <Sider width={230} trigger={null} collapsible={true} collapsed={menuCollapsed} className="menu_leftSider" onMouseEnter={!menuFixed ? () => setMenuCollapsed(false) : undefined} onMouseLeave={!menuFixed ? () => setMenuCollapsed(true) : undefined}>
                <div className={`menu_logoCollapsed ${!menuCollapsed ? ' menu_logo' : undefined}`} onClick={() => { navigate(`/${packProps.homepage}`) }}></div>
                <div className="menu_search">
                    <SearchText
                        value={search}
                        onChange={searchText}
                        props={{ collapsed: menuCollapsed.toString() }}
                        borderColor={COLORS.blue_main(1)}
                        textColor={COLORS.white_color1}
                        name={"search"}
                        backgroundcolor={COLORS.blue_main(1)}
                        placeholdercolor={COLORS.blue_inactive(1)}
                        active={true}
                        opacity={0.51}
                        placeholder="Buscar"
                    />
                </div>
                <div className="menu_wrapper">
                    <Menu mode="inline" selectedKeys={[itemSelected?.menuID.toString() || '0']} className="menu_menu" items={menuSearch} onClick={(e) => navigateTo(parseInt(e.key))} />
                </div>

                <div className="menu_footer"></div>
            </Sider>

            <Layout className="menu_siteLayout">
                <Header className="menu_header">
                    <div className="menu_collapsedIcon" onClick={() => { setMenuCollapsed(!menuCollapsed); setMenuFixed(!menuFixed) }}>
                        {menuCollapsed ? <MenuUnfoldOutlined className='trigger' /> : <MenuFoldOutlined className='trigger' />}
                        <div className="menu_currentPage">{currentPage}</div>
                    </div>
                    <Dropdown trigger={['hover']} overlay={<ConfigurationOptions />} placement="bottom">
                        <div className="menu_user">
                            <div className="name">{userInformation?.primerNombre} {userInformation?.primerApellido}</div>
                            <div className="figure">
                                {!!userInformation?.fotoPerfil
                                    ? <img className="photo" src={userInformation!.fotoPerfil!} />
                                    : <i className="fa-solid fa-user default_photo"></i>
                                }
                            </div>
                        </div>
                    </Dropdown>
                </Header>
                <Content className="menu_content">
                    {children}
                </Content>
            </Layout>

            <Modal props={{ style: { top: '-10px' } }} title="Configuración" visible={visibleConf} setVisible={setVisibleConf} askBeforeClose={askBeforeClosing}>
                <Configuration setVisibleConf={setVisibleConf} setAskBeforeClosing={setAskBeforeClosing} />
            </Modal>

            <ConfirmationModal
                visible={visibleClose}
                setVisible={setVisibleClose}
                question="¿Deseas cerrar la sesión?"
                method={handleSignOut}
                loading={closeSessionLoading}
            />
        </Layout>
    )
}

export default MenuLayout;